// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1671":"caee83e6","1775":"c46ea2c6","1798":"939baee9","4374":"caee83e6","7551":"c4305a33","8010":"0b5fd7c2"}[chunkId] + ".chunk.css";
};